import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  GaugeIcon,
  UsersThreeIcon,
  WrenchIcon,
  ReceiptIcon,
  PackageIcon,
  FileTextIcon,
  ChartLineUpIcon,
  GearSixIcon,
  SignOutIcon,
  CircuitryIcon,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Dashboard", icon: GaugeIcon, end: true, testid: "nav-dashboard" },
  { to: "/clientes", label: "Clientes", icon: UsersThreeIcon, testid: "nav-clientes" },
  { to: "/ordens", label: "Ordens de Serviço", icon: WrenchIcon, testid: "nav-ordens" },
  { to: "/gastos", label: "Gastos", icon: ReceiptIcon, testid: "nav-gastos" },
  { to: "/estoque", label: "Estoque", icon: PackageIcon, testid: "nav-estoque" },
  { to: "/notas", label: "Notas Fiscais", icon: FileTextIcon, testid: "nav-notas" },
  { to: "/financeiro", label: "Financeiro", icon: ChartLineUpIcon, testid: "nav-financeiro" },
  { to: "/configuracoes", label: "Configurações", icon: GearSixIcon, testid: "nav-config" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/login", { replace: true });
  };

  return (
    <aside
      className="fixed inset-y-0 left-0 w-64 z-40 glass border-r border-white/5 flex flex-col"
      data-testid="sidebar"
    >
      <div className="px-6 pt-6 pb-5 border-b border-white/5">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center shadow-[0_0_20px_rgba(59,130,246,0.4)]">
            <CircuitryIcon size={22} weight="duotone" className="text-white" />
          </div>
          <div>
            <div className="font-display text-base font-bold leading-tight">Assistência</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-blue-400/80">Manager</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
        {NAV.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                isActive
                  ? "bg-blue-600/15 text-blue-300 border border-blue-500/30 shadow-[inset_0_0_12px_rgba(59,130,246,0.1)]"
                  : "text-slate-400 hover:bg-white/5 hover:text-white border border-transparent"
              }`
            }
          >
            <Icon size={18} weight="duotone" />
            <span className="font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-white/5">
        <div className="flex items-center gap-3 px-3 py-2 rounded-lg bg-white/5">
          <div className="h-8 w-8 rounded-full bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center text-xs font-bold">
            {user?.name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium truncate">{user?.name || "Usuário"}</div>
            <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="p-1.5 rounded-md hover:bg-white/10 text-slate-400 hover:text-rose-400 transition-colors"
            title="Sair"
          >
            <SignOutIcon size={16} weight="bold" />
          </button>
        </div>
      </div>
    </aside>
  );
}
